import { apiClient } from './client';

export interface TeamMember {
  id: number;
  user_id: string;
  role: 'player' | 'captain' | 'co_captain';
  ranking_position?: number;
  invite_status: 'pending' | 'accepted';
  is_active: boolean;
  user?: { id: string; first_name: string; last_name: string; photo_url?: string; level?: string };
}

export interface TeamInvitation {
  id: number;
  team_id: number;
  team_name: string;
  captain_name: string;
  invite_status: string;
  joined_at: string;
}

export interface Team {
  id: number;
  name: string;
  logo_url?: string;
  home_location?: string;
  captain_id: string;
  created_at: string;
  members?: TeamMember[];
}

export interface TeamCreate {
  name: string;
  home_location?: string;
}

export interface TeamUpdate {
  name?: string;
  home_location?: string;
}

export const teamsApi = {
  listMine: () => apiClient.get<Team[]>('/api/teams/me'),
  create: (data: TeamCreate) => apiClient.post<Team>('/api/teams', data),
  get: (id: number) => apiClient.get<Team>(`/api/teams/${id}`),
  update: (id: number, data: TeamUpdate) => apiClient.put<Team>(`/api/teams/${id}`, data),
  getMembers: (id: number) => apiClient.get<TeamMember[]>(`/api/teams/${id}/members`),
  inviteMember: (id: number, email: string) =>
    apiClient.post(`/api/teams/${id}/members`, { email }),
  removeMember: (teamId: number, userId: string) =>
    apiClient.delete(`/api/teams/${teamId}/members/${userId}`),
  updateRanking: (id: number, rankings: { user_id: string; ranking_position: number }[]) =>
    apiClient.put(`/api/teams/${id}/ranking`, { rankings }),
  acceptInvitation: (teamId: number) =>
    apiClient.post(`/api/teams/${teamId}/invitations/accept`),
  declineInvitation: (teamId: number) =>
    apiClient.post(`/api/teams/${teamId}/invitations/decline`),
  getMyInvitations: () => apiClient.get<TeamInvitation[]>('/api/teams/invitations/me'),
};
